import React from 'react';
import {get} from 'lodash';
import moment from 'moment';
import axios from 'axios';
import { bool, string, func } from 'prop-types'

import {
  metaLoading,
} from '../lib/helpers';

import Loading from './Loading';
import Modal from './Modal';

class NoteHistoryModal extends React.Component {

  static propTypes = {
    onToggleModal: func.isRequired,
    isActive: bool.isRequired,
    notesPath: string.isRequired,
    title: string,
    description: string
  }

  static defaultProps = {
    title: 'Notes history',
    description: 'This was noted by an admin.'
  };

  state = {
    ...metaLoading,
    notes: [],
  };

  componentDidUpdate(prevProps) {
    if (this.props.isActive && !prevProps.isActive && this.state.notes.length === 0) {
      axios.get(this.props.notesPath)
      .then((res) => {
        if (res.status == 200 && get(res, 'data')) {
          this.setState({
            notes: res.data['notes'],
            meta: {
              isLoading: false
            },
          })
        }
      })
    }
  }

  componentDidMount() {
    this.setState({
      meta: {
        isLoading: true,
      },
    })
  }

  render = () => {
    return (
      <Modal
        isActive={this.props.isActive}
        onToggleModal={this.props.onToggleModal}
      >
        <h3 className='Modal__h3'>{this.props.title}</h3>

        <div className='UserNoteHistoryModal'>
          <p className='UserNoteHistoryModal__p'>{this.props.description}</p>

          <Loading
            isLoading={get(this.state, 'meta.isLoading') && get(this.state, 'notes.length', 0) == 0}
          >
            <dl className='UserNoteHistoryModal__dl'>
              {get(this.state, 'notes', []).map((note) => (
                <div className='UserNoteHistoryModal__dl__item' key={note.id}>
                  <p>{note.id}</p>
                  <time data-datetime={moment(note.createdAt).format()}>{moment(note.createdAt).format('YYYY-MM-DD HH:mm')}</time>
                  <dt>
                    {note.banTime && <span className='Badge Badge--orange'>{note.banTime}</span>}
                    {note.adminEmail}
                  </dt>
                  <dd>{note.note}</dd>
                </div>
              ))}
            </dl>
          </Loading>
        </div>
      </Modal>
    );
  }
}

export default NoteHistoryModal;
